import { usePathname, useSearchParams } from 'next/navigation';

/**
 * This hook is a replacement for `useRouter().asPath` in Next.js.
 * NOTE: You need to surround a component using this hook with a Suspense boundary due to useSearchParams.
 * @returns The current path and search parameters as a string.
 */
export function useAsPath() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const params = searchParams && searchParams.toString() === '?' ? searchParams.toString() : '';

  return pathname + params;
}
